<div class="container mt-4" *ngIf="notification; else loading">
  
  <div class="noti-card shadow-sm">

    <!-- Title -->
    <h2 class="noti-title">
      {{ currentLang === 'ar' ? notification.title_ar : notification.title_en }}
    </h2>

    <!-- Body -->
    <p class="noti-body">
      {{ currentLang === 'ar' ? notification.body_ar : notification.body_en }}
    </p>

    <!-- Sender -->
    <div class="noti-row" *ngIf="notification.user">
      <i class="fas fa-user"></i>
      <span class="mx-2">{{ notification.user.name || 'N/A' }}</span>
    </div>

    <!-- Phone -->
    <div class="noti-row" *ngIf="notification.user">
      <i class="fas fa-phone"></i>
      <span class="mx-2">{{ notification.user.phone_without_code || 'N/A' }}</span>
    </div>

    <!-- Date -->
    <div class="noti-date">
      <i class="fas fa-clock"></i>
      {{ notification.created_at | date: 'medium' }}
    </div>

  </div>

</div>

<ng-template #loading>
  <div class="container text-center py-5">
    <div class="spinner-border text-warning"></div>
    <p class="mt-3">{{ 'MENU.DASHBOARD.loading_employee_details' | translate }}</p>
  </div>
</ng-template>
